/**
 * Suspense fallback shown while a lazy-loaded route chunk is downloading.
 * Stays subtle — uses the same electric pulse as our brand accents, no big
 * full-screen takeover. Auto-fades in after 120ms so flicker-free chunk loads
 * never show the spinner at all.
 */
import { useEffect, useState } from "react";

export default function RouteSpinner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShow(true), 120);
    return () => clearTimeout(t);
  }, []);

  return (
    <div
      className={`min-h-screen flex items-center justify-center bg-[#050505] transition-opacity duration-200 ${
        show ? "opacity-100" : "opacity-0"
      }`}
      data-testid="route-spinner"
    >
      <div className="flex flex-col items-center gap-4">
        <div className="relative w-10 h-10">
          <span className="absolute inset-0 rounded-full border-2 border-electric/20" />
          <span className="absolute inset-0 rounded-full border-2 border-transparent border-t-electric animate-spin" />
        </div>
        <div className="font-display text-[11px] uppercase tracking-[0.25em] text-white/40">
          Loading
        </div>
      </div>
    </div>
  );
}
